import { render, staticRenderFns } from "./AdminReopenUmbAccount.vue?vue&type=template&id=47d88a48"
import script from "./AdminReopenUmbAccount.vue?vue&type=script&lang=ts"
export * from "./AdminReopenUmbAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports